import React, {useEffect, useState} from 'react';
import SidebarComponent from 'pages/sidebar';
import { Button, Col, Container, Row, Spinner } from 'reactstrap';
import "./dashboard.scss"
import { Bell, ChevronRight, MusicSecondary, MusicYellow, PeopleQuestion, Sort } from 'assets';
import CustomButton from 'components/CustomButton';
import DashboardChart from './DashboardChart';
import Table from 'components/Table';
import InfoCard from './InfoCard';
import { API_GET_MAMBOO } from 'services';
import data from './dashboardDummy'
import StatusBadge from 'components/StatusBadge';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'services/cookies';

const Dashboard = () => {
  const [valueCard, setValueCard] = useState({})
  const [valueChart, setValueChart] = useState({})
  const [valueChartProgress, setValueChartProgress] = useState({})
  const [dataTable, setDataTable] = useState([])
  const [isLoadingPage, setIsLoadingPage] = useState(false)
  const [isVerified, setIsVerified] = useState(false)
  const profile = getCookie('profile')
  const navigate = useNavigate()
  // const data = false
  // const user = 'pencipta'
  const user = getCookie('publisher') == 1 ? "publisher" : null
  const isPencipta = getCookie('publisher') == 3
  const publisherContent = {
    title: "Segera Verifikasi Publisher",
    text: "Buka semua fitur yang ada dengan cara melengkapi dokumen yang ada dan nantinya akan kami verifikasi terlebih dahulu",
    buttonLabel: "Verifikasi sekarang"
  }

  const penciptaContent = {
    title: "Bingung gunain dashboard mu?",
    text: "Tersedia panduan penggunaan dashboard agar kamu bisa optimalkan akun dashboard-mu.",
    buttonLabel: "Pelajari Lebih Lanjut"
  }

  const infoCardContent = [
    {
      CardIcon: MusicYellow,
      title: 'Lagu Terdaftar',
      data: valueCard && valueCard?.lagu_terdaftar
    },
    {
      CardIcon: MusicSecondary,
      title: user === 'publisher' ? "Jumlah Anggota Songwriter" : "Lagu Terjual",
      data: user === 'publisher' ? valueCard && valueCard?.anggota_terdaftar : valueCard && valueCard?.lagu_terjual
    },
    {
      CardIcon: MusicSecondary,
      title: user === 'publisher' ? "Lagu Terjual" : "Proyek Aktif",
      data: user === 'publisher' ? valueCard && valueCard?.lagu_terjual : valueCard && valueCard?.lisensi_aktif
    },
    {
      CardIcon: MusicSecondary,
      title: user === 'publisher' ? "Lagu Lisensi Aktif" : "Pembaruan Lisensi",
      data: valueCard && valueCard?.lisensi_aktif
    }
  ]

  // Segmen chart dibangun dari satu sumber agar label dan warna dataset
  // selalu sejajar saat ada segmen yang disembunyikan.
  const buildChartSegments = (value) => [
    {
      label: 'Mechanical',
      color: '#FF3A29',
      total: value && value?.mech
    },
    {
      label: 'Synchron',
      color: '#FFB200',
      total: value && value?.sync
    },
    // Performing tidak ditampilkan untuk pencipta (role_code 3).
    ...(isPencipta ? [] : [{
      label: 'Performing',
      color: '#4339F2',
      total: value && value?.perform
    }]),
    {
      label: 'DSP',
      color: '#43936C',
      total: value && value?.dsp
    }
  ]

  const buildChartDataset = (segments) => ({
    datasets: [
      {
        data: segments.map((segment) => segment.total),
        backgroundColor: segments.map((segment) => segment.color),
        borderColor: segments.map((segment) => segment.color),
        borderWidth: 1,
      },
    ],
  })

  const lisensiSegments = buildChartSegments(valueChart)
  const lisensiProgressSegments = buildChartSegments(valueChartProgress)

  const chartData = {
    leftChart: {
      title: 'Total Lisensi',
      subTitle: 'Nilai project saat ini',
      nominal: valueChart && valueChart?.total_transaction,
      chartLabel: lisensiSegments,
      data: buildChartDataset(lisensiSegments)
    },
    rightChart: {
      title: 'Lisensi on Progress',
      subTitle: 'Lisensi dalam progress',
      nominal: valueChartProgress && valueChartProgress?.total_transaction,
      chartLabel: lisensiProgressSegments,
      data: buildChartDataset(lisensiProgressSegments)
    }
  }

  const badgeFormatter = (cell) => {
    switch (cell) {
      case 'Dalam Pemakaian':
        return <StatusBadge customStyle={{ color: "#BF6919", border: "1px solid var(--warning-border)", background: 'var(--surface-2)' }} title={cell} />
      case 'Tersedia':
        return <StatusBadge customStyle={{ color: "#367A59", border: "1px solid var(--success-border)", background: 'var(--surface-2)' }} title={cell} />
      case 'Tidak Tersedia':
        return <StatusBadge customStyle={{ color: 'var(--text-muted)', border: '1px solid var(--border)', background: 'var(--surface-2)' }} title={cell} />
    }
  }

  const formatDate = (cell) => {
    const startDate = new Date(cell.split(" - ")[0]);

    const options = { year: "2-digit", month: "short", day: "2-digit" };
    const startFormatted = startDate.toLocaleDateString("id-ID", options).replace(",", "");

    return startFormatted;
  }


  const columnRefs = [
    {
      dataField: 'creator_name',
      text: <><span>Songwriter</span><Sort /></>,
      sort: true
    },
    {
      dataField: 'song_title',
      text: <><span>Judul Lagu</span><Sort /></>,
      sort: true
    }, 
    {
      dataField: 'genre',
      text: 'Genre'
    },
    {
      dataField: 'created_at',
      text: <><span>Tanggal</span><Sort /></>,
      sort: true,
      formatter: (cell, row) => formatDate(cell)
    },
    {
      dataField: 'status',
      text: 'Status',
      formatter: (cell, row) => badgeFormatter(cell)
    }
  ];

  const emptyState = (content) => {
    return (
      <>
        <Row>
          <Col md={6}>
            <DashboardChart />
          </Col>
          <Col md={6}>
            <div className='verification-info-card'>
              <PeopleQuestion />
              <div className='info-card-content'>
                <span className='info-card-title'>{content.title}</span>
                <span className='info-card-text'>{content.text}</span>
                <CustomButton
                  label={content.buttonLabel}
                  color="primary-btn"
                  size="btn-sm"
                  onClick={() => {
                    !isVerified && navigate('/profile')
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </>

    )
  }

  useEffect(() => {
    setIsLoadingPage(true)
    API_GET_MAMBOO.dynamic.getDashboard().then((resp) => {
      setIsVerified(resp.is_verified)
      setValueCard({
        ...valueCard,
        anggota_terdaftar: Number(resp.anggota_terdaftar),
        lagu_terdaftar: Number(resp.lagu_terdaftar),
        lagu_terjual: Number(resp.lagu_terjual),
        lisensi_aktif: Number(resp.lisensi_aktif),
      });
      setValueChart({
        ...valueChart,
        mech: Number(resp.lisence.mech),
        sync: Number(resp.lisence.sync),
        perform: Number(resp.lisence.perform),
        dsp: Number(resp.lisence.dsp),
        total_transaction: resp.lisence.total_transaction
      });
      setValueChartProgress({
        ...valueChartProgress,
        mech: Number(resp.lisence_on_progress.mech),
        sync: Number(resp.lisence_on_progress.sync),
        perform: Number(resp.lisence_on_progress.perform),
        dsp: Number(resp.lisence_on_progress.dsp),
        total_transaction: resp.lisence_on_progress.total_transaction
      });
      setIsLoadingPage(false)
    });

    API_GET_MAMBOO.dynamic
      .getDashboardList()
      .then((resp) => {
        setDataTable(resp.data);
      })
      .catch(() => {
        setDataTable([]);
      });
  }, []);

  return (
    <Container fluid className="dashboard-container">
      {isLoadingPage ? (
        <div
          className="d-flex align-items-center justify-content-center flex-column"
          style={{ height: "100vh" }}
        >
          <Spinner />
          <p className="mt-3">Mohon tunggu...</p>
        </div>
      ) : (
        <>
          <div className="header-container">
            {user === "publisher" && (
              <div className="dashboard-header">
                <h1>Dashboard</h1>
                <span>{`Welcome back, ${profile}`}</span>
              </div>
            )}
            <div className="icon-wrapper">
              <Bell />
            </div>
          </div>
          <div className="dashboard-content">
            <div className="content-container">
              <div className="info-card-container">
                {infoCardContent.map((content) => (
                  <InfoCard content={content} key={content.title} />
                ))}
              </div>
            </div>

            <div className="chart-container">
              {isVerified ? (
                <Row>
                  <Col md={6}>
                    <DashboardChart data={chartData.leftChart} />
                  </Col>
                  <Col md={6}>
                    <DashboardChart data={chartData.rightChart} />
                  </Col>
                </Row>
              ) : (
                emptyState(
                  user === "publisher" ? publisherContent : penciptaContent
                )
              )}
            </div>
            <div className="table-container">
              <Table
                columnRefs={columnRefs}
                dataTable={dataTable}
                noDataText="Belum Ada Katalog Lagu"
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "end" }}>
            {isVerified && (
              <CustomButton
                label={
                  user === "publisher" ? "Lihat Katalog Lagu" : "Lihat Laporan"
                }
                color="primary-btn"
                iconColor="white"
                LabelIcon={ChevronRight}
                onClick={() =>
                  navigate(
                    `${user === "publisher" ? "/katalog-lagu" : "/pendapatan"}`
                  )
                }
              />
            )}
          </div>
        </>
      )}
    </Container>
  );
}

export default Dashboard